import { render, staticRenderFns } from "./ProjectionExplained.vue?vue&type=template&id=33379e72&scoped=true&"
import script from "./ProjectionExplained.vue?vue&type=script&lang=js&"
export * from "./ProjectionExplained.vue?vue&type=script&lang=js&"
import style0 from "./ProjectionExplained.vue?vue&type=style&index=0&id=33379e72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33379e72",
  null
  
)

export default component.exports